import { render, staticRenderFns } from "./CamposIntegracao.vue?vue&type=template&id=0798ce8f&scoped=true"
import script from "./CamposIntegracao.vue?vue&type=script&lang=js"
export * from "./CamposIntegracao.vue?vue&type=script&lang=js"
import style0 from "./CamposIntegracao.vue?vue&type=style&index=0&id=0798ce8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0798ce8f",
  null
  
)

export default component.exports